import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import EmptyCategory from "../../assets/img/empty-category.svg";

const useStyles = makeStyles(theme => ({
  emptyWrap: {
    backgroundColor: theme.palette.common.white,
    padding: "40px 16px !important",
    textAlign: "center",
  },
  emptyContent: {
    width: "100%",
    maxWidth: "60ch",
    margin: "0 auto",
  },
  emptyText: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    fontWeight: 500,
    marginTop: 10,
  },
  emptyTip: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    fontStyle: "italic",
    marginTop: 10,
  },
}));

const DetailedSearchEmptyList = ({ buttonLabel }) => {
  const classes = useStyles();
  const intl = useIntl();

  const effectiveButtonLabel =
    buttonLabel?.trim() ||
    intl.formatMessage({
      id: "search.filter",
    });

  return (
    <Grid item xs={12} className={classes.emptyWrap}>
      <div className={classes.emptyContent}>
        <img src={EmptyCategory} alt="Empty" />

        <Typography className={classes.emptyText}>
          <FormattedMessage id="search.detailedSearch.emptyResult.message" />
        </Typography>

        <Typography className={classes.emptyTip}>
          <FormattedMessage
            id="search.detailedSearch.emptyResult.tip"
            values={{ buttonLabel: effectiveButtonLabel  }}
          />
        </Typography>
      </div>
    </Grid>
  );
};

DetailedSearchEmptyList.propTypes = {
  buttonLabel: PropTypes.string,
};

export default DetailedSearchEmptyList;
